import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import AppBar from '../../../../components/AppBar';
import Layout from '../../../../components/Layout';
import ScrollArea from '../../../../components/ScrollArea';
import TabsLinks from '../../../../components/TabsLinks';
import FormAverageRating from '../../../../forms/FormAverageRating';
import { paths } from '../../../../routes';
import TableRatings from './components/TableRatings';
import { StyledRatings, StyledRatingsContent } from './styled';
import PlaceSelect from '../../components/PlaceSelect';
import Loader from '../../../../components/Loader';
import { useApi } from '../../../../hooks/useApi';
import { ApiRankings } from '../../../../api/rankings';
import NoData from './components/NoData';
import { parseRatings } from '../../../../utils/helpers';
import { useTranslation } from 'react-i18next';

const Ratings = () => {
    const { t } = useTranslation()
    const role = useSelector(state => state.auth.user?.user?.role?.type);
    const placesLoading = useSelector(state => state.places.loading);
    const placeSelected = useSelector(state => state.places.selected);
    const placesData = useSelector(state => state.places.data);

    const [ratings, setRatings] = useState(null);

    // Setup request
    const [{ loading: ratingsLoading }, getPlaceRankings] = useApi(ApiRankings.getPlaceRankings, { manual: true });

    const ratingsData = useMemo(
        () => (
            ratings && parseRatings(ratings)
        ),
        [ratings]
    );

    const handleSubmit = async (data) => {
        const res = await getPlaceRankings(data);

        if (res?.data) {
            setRatings(res?.data);
        }
    };

    const handleAfterChangePlace = useCallback(
        () => setRatings(null),
        []
    );

    return (
        <StyledRatings>
            <AppBar>
                <PlaceSelect />
            </AppBar>
            <TabsLinks
                tabs={[{
                    to: paths.ratings,
                    name: t('Oceny od pracowników')
                }]}
            />
            <Layout>
                <ScrollArea>
                    <StyledRatingsContent>
                        <FormAverageRating
                            initialValues={placeSelected?.id !== 'all' ? { place_id: placeSelected?.id } : {}}
                            role={role}
                            loading={ratingsLoading}
                            onSubmit={handleSubmit}
                            places={placesData}
                            placeSelected={placeSelected}
                            onAfterChangePlace={handleAfterChangePlace}
                        />
                        {(ratingsData && ratingsData.length > 0) && <TableRatings data={ratingsData} />}
                        {(ratingsData && ratingsData.length === 0) && <NoData />}
                    </StyledRatingsContent>
                </ScrollArea>
            </Layout>
            <Loader show={placesLoading || ratingsLoading} />
        </StyledRatings>
    )
}

export default Ratings;
